import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import blogService from '../../services/blogService';
import { FaEdit, FaTrash, FaPlus } from 'react-icons/fa';

const BlogPosts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    fetchPosts();
  }, []);

  const fetchPosts = async () => {
    try {
      setLoading(true);
      const data = await blogService.getAllPosts();
      setPosts(data);
      setError(null);
    } catch (err) {
      setError('Failed to fetch posts');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this post?')) {
      try {
        await blogService.deletePost(id);
        setPosts(posts.filter(post => post._id !== id));
      } catch (err) {
        setError('Failed to delete post');
        console.error(err);
      }
    }
  };

  const handleEdit = (id) => {
    navigate(`/admin/posts/edit/${id}`);
  };

  const handleCreate = () => {
    navigate('/admin/posts/create');
  };

  if (loading) return <div className="loading">Loading posts...</div>;
  if (error) return <div className="error">{error}</div>;

  return (
    <div className="admin-blog-posts">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <h1>Manage Blog Posts</h1>
        <button className="btn btn-primary" onClick={handleCreate}>
          <FaPlus className="me-2" />
          Create New Post
        </button>
      </div>

      <div className="blog-posts-table card">
        <div className="table-responsive">
          <table className="table">
            <thead>
              <tr>
                <th>Title</th>
                <th>Category</th>
                <th>Author</th>
                <th>Status</th>
                <th>Created At</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {posts.length === 0 ? (
                <tr>
                  <td colSpan="6" className="text-center">No posts available yet.</td>
                </tr>
              ) : (
                posts.map(post => (
                  <tr key={post._id}>
                    <td>{post.title}</td>
                    <td>{post.category?.name || 'Uncategorized'}</td>
                    <td>{post.author}</td>
                    <td>
                      <span className={`badge ${post.published ? 'bg-success' : 'bg-warning'}`}>
                        {post.published ? 'Published' : 'Draft'}
                      </span>
                    </td>
                    <td>{new Date(post.createdAt).toLocaleDateString()}</td>
                    <td>
                      <div className="btn-group">
                        <button
                          className="btn btn-sm btn-outline-primary me-1"
                          onClick={() => handleEdit(post._id)}
                        >
                          <FaEdit />
                        </button>
                        <button
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => handleDelete(post._id)}
                        >
                          <FaTrash />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default BlogPosts; 